const $mainSlider = $('.m-hero-slider__list, .m-gallery-slider__list, .m-cat-slider__list');
const $ticker = $('.m-info-slider__list');

$mainSlider.each(function forEachSlider() {
  const $this = $(this);
  const $parent = $(this).parent();
  const isRowSlider = $(this).attr('data-row');
  const rowsPerSlide = parseInt($(this).attr('data-row'), 10);
  const dataSlides = parseInt($(this).attr('data-slides'), 10);
  const dataSlidesScroll = parseInt($(this).attr('data-slides-scroll'), 10);

  let responsive = [];

  if (isRowSlider) {
    responsive = [
      {
        breakpoint: 768,
        settings: {
          slidesPerRow: 1,
          rows: rowsPerSlide,
        }
      }
    ]
  }

  if (dataSlides) {
    responsive = [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: dataSlidesScroll ? 1 : undefined,
        }
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  }

  if ($this.children().length > 1) {
    $this.slick({
      infinite: true,
      arrows: true,
      autoplaySpeed: 9000,
      slidesToShow: dataSlides || undefined,
      slidesToScroll: dataSlidesScroll || undefined,
      autoplay: true,
      dots: true,
      dotsClass: 'm-slider-ctrls__list',
      prevArrow: $parent.find('.m-slider-arrow--prev'),
      nextArrow: $parent.find('.m-slider-arrow--next'),
      appendDots: $parent.find('.m-slider-ctrls__pager'),
      slidesPerRow: isRowSlider ? 4 : undefined,
      rows: isRowSlider ? rowsPerSlide : undefined,
      responsive,
    }).after(() => {
      $this.find('.m-hero-slider__item[data-slider-label]').each(function (event) {
        const label = $(this).attr('data-slider-label');
        if (label) {
          const ctrl = $(this).attr('aria-describedby');
          $('#' + ctrl).html(label).attr('data-slider-label', label);
        }
      });
    });
  }
});

$ticker.each(function forEachTicker() {
  const $this = $(this);
  const $parent = $(this).parent();

  if ($this.children().length > 1) {
    $this.slick({
      infinite: true,
      arrows: true,
      autoplaySpeed: 9000,
      autoplay: true,
      dots: false,
      prevArrow: $parent.find('.m-slider-arrow--prev'),
      nextArrow: $parent.find('.m-slider-arrow--next'),
    });
  }
});
